//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import * as systemAlertsApi from '@apis/system-alerts/systemAlertsApi';
import { createNgApiAdapterService, GetNgApiAdapterType } from './createNgApiAdapter';

const systemAlertsApiService = createNgApiAdapterService(systemAlertsApi);
export type SystemAlertsApiService = GetNgApiAdapterType<typeof systemAlertsApiService>;

// Backwards compatibility: Use the old service name
angular.module('curalate').service('SystemAlertsApiService', systemAlertsApiService);
